/*
 * As abas do topo das páginas Sobre e Diretrizes (Sobre, Diretrizes, Termos de Serviço, Política de Privacidade). Cada aba só existe
 * quando há conteúdo: as Diretrizes com o recurso ligado, Termos e
 * Privacidade com um endereço (do fof/terms ou do admin do tema). As outras
 * políticas do fof/terms entram depois, com o próprio nome. Entre Diretrizes
 * e Termos ficam as páginas do fof/pages que o admin acrescentou à área.
 */
import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import { forumBool, t } from '../../utils/settings';

/** Uma aba extra (atributo `canelaAboutPages` do fórum, já filtrado pela visibilidade). */

export function legalPages() {
  const pages = app.forum.attribute('canelaLegalPages');
  return Array.isArray(pages) ? pages.filter(page => page && typeof page.url === 'string' && page.url) : [];
}
export function aboutPages() {
  const pages = app.forum?.attribute('canelaAboutPages');
  return Array.isArray(pages) ? pages.filter(page => page && Number(page.id) > 0) : [];
}
export function findAboutPage(id) {
  return aboutPages().find(page => Number(page.id) === id);
}

/** O nome da aba ativa de uma página extra (cada uma tem o seu). */
export function aboutPageTab(id) {
  return `canela.about_page:${id}`;
}
export function aboutPageUrl(page) {
  return app.route('canela.about_page', {
    page: page.slug ? `${page.id}-${page.slug}` : String(page.id)
  });
}
export function guidelinesEnabled() {
  return forumBool('canelaGuidelinesEnabled', false);
}
function isActive(routeName, active) {
  return routeName === active || active === 'canela.guidelines' && routeName === 'canela.faq';
}
export default function AboutNav(active) {
  const tabs = [];
  const internal = (tab, href, label, icon) => m("li", {
    className: isActive(tab, active) ? 'active' : ''
  }, m(LinkButton, {
    href: href,
    active: isActive(tab, active),
    icon: icon || undefined
  }, label));
  if (forumBool('canelaAboutEnabled', true)) tabs.push(internal('canela.about', app.route('canela.about'), t('community.about.title')));
  if (guidelinesEnabled()) tabs.push(internal('canela.guidelines', app.route('canela.guidelines'), t('community.guidelines.title')));
  aboutPages().forEach(page => tabs.push(internal(aboutPageTab(Number(page.id)), aboutPageUrl(page), page.label, page.icon)));
  legalPages().forEach(page => {
    const label = page.key === 'tos' ? t('community.legal.tos') : page.key === 'privacy' ? t('community.legal.privacy') : page.title || page.url;
    const external = /^https?:\/\//i.test(page.url);
    tabs.push(m("li", {
      className: `CanelaAbout-navLegal CanelaAbout-navLegal--${page.key}`
    }, m("a", Object.assign({
      href: page.url
    }, external ? {
      target: '_blank',
      rel: 'noopener'
    } : {}), label)));
  });

  // Uma aba sozinha não é navegação.
  if (tabs.length < 2) return null;
  return m("nav", {
    className: "CanelaAbout-nav"
  }, m("ul", null, tabs));
}
flarum.reg.add('ramon-canela', 'forum/features/community/AboutNav', AboutNav);